import { useCallback, useEffect, useState } from 'react';

const PORTRAIT_QUERY = '(orientation: portrait)';

function readPortrait() {
  return typeof window.matchMedia === 'function' && window.matchMedia(PORTRAIT_QUERY).matches;
}

/**
 * Hält das Brett am Handy im Querformat: meldet Hochformat und kann Vollbild
 * samt Quersperre anfordern. Fehlende Browser-Unterstützung wird still übergangen.
 */
export function useOrientationLock({ enabled }) {
  const [isPortrait, setIsPortrait] = useState(readPortrait);

  useEffect(() => {
    if (!enabled || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(PORTRAIT_QUERY);
    const handler = (e) => setIsPortrait(e.matches);
    setIsPortrait(mq.matches);
    mq.addEventListener?.('change', handler);
    return () => mq.removeEventListener?.('change', handler);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    return () => {
      try { window.screen?.orientation?.unlock?.(); } catch { /* Sperre nicht verfügbar */ }
      try {
        if (document.fullscreenElement) {
          Promise.resolve(document.exitFullscreen?.()).catch(() => {});
        }
      } catch { /* Vollbild nicht verfügbar */ }
    };
  }, [enabled]);

  const requestLandscape = useCallback(async () => {
    try { await document.documentElement.requestFullscreen?.(); } catch { /* Vollbild verweigert */ }
    try { await window.screen?.orientation?.lock?.('landscape'); } catch { /* Sperre verweigert */ }
  }, []);

  return { isPortrait, requestLandscape };
}
